/**
 * One byte formatter for everything the user sees a size in.
 *
 * There were three, each hard-coded to a single unit and each wrong at a different end of the
 * scale — measured, not guessed:
 *
 *   - the zip picker printed KB with one decimal, so a 30 MiB archive read `30720.0 KB`;
 *   - the extension inbox printed KB with none, so every capture under half a kilobyte read
 *     `0 KB` — including, in a list, several in a row that were plainly different sizes;
 *   - the upload progress printed MB with two decimals, so a 40 KiB file read `0.04 MB` and an
 *     800-byte one `0.00 MB`, and the progress line sat at `0.00 MB of 0.00 MB` throughout.
 *
 * `pretty-bytes` picks the unit instead. Binary units, because every limit in this codebase is
 * written binary (`50 * 1024 * 1024`), so a size shown next to "50 MiB max" is directly
 * comparable to it — which is the only reason these strings are on screen.
 */
import prettyBytes from "pretty-bytes";

export function formatBytes(bytes: number): string {
  return Number.isFinite(bytes) ? prettyBytes(Math.max(0, bytes), { binary: true }) : "—";
}
